import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle } from 'react';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { Box, OutlinedInput, Typography, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
const MetricsField = ({ label, firstField, lastField }) => {
    return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }, children: [_jsx(Typography, { variant: 'body2', color: 'textDisabled', children: label }), _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }, children: [_jsx(OutlinedInput, { ...firstField, type: 'number', fullWidth: true, sx: { maxWidth: 94 }, disabled: true }), "-", _jsx(OutlinedInput, { ...lastField, type: 'number', fullWidth: true, sx: { maxWidth: 94 }, disabled: true })] })] }));
};
const ConfigureMetricsForm = forwardRef(({ onSubmitHandler, assetId }, ref) => {
    const { getScoreCardSetting } = useSelector((state) => state.scoreCardSlice);
    const categories = ['No Alarm', 'Average', 'High', 'Extremely High'];
    const { control, handleSubmit, getValues } = useForm({
        defaultValues: {
            metrics: categories.map((categoryName) => ({
                id: getScoreCardSetting.scoreCardMerits.find((c) => c.categoryName === categoryName)?.id ||
                    null,
                assetId: '86AAC17D-397E-404F-9242-C4F1F2052B34',
                categoryName,
                lowerLimit: getScoreCardSetting.scoreCardMerits.find((c) => c.categoryName === categoryName)
                    ?.lowerLimit || 0,
                upperLimit: getScoreCardSetting.scoreCardMerits.find((c) => c.categoryName === categoryName)
                    ?.upperLimit || 0
            }))
        }
    });
    const { fields } = useFieldArray({ control, name: 'metrics' });
    useImperativeHandle(ref, () => ({
        submitForm: () => {
            const data = getValues();
            onSubmitHandler(data);
        }
    }));
    return (_jsx(Grid, { container: true, spacing: 2, children: fields.map((item, index) => (_jsx(Grid, { item: true, xs: 12, children: _jsx(Controller, { name: `metrics.${index}.lowerLimit`, control: control, render: ({ field: firstField }) => (_jsx(Controller, { name: `metrics.${index}.upperLimit`, control: control, render: ({ field: lastField }) => (_jsx(MetricsField, { label: item.categoryName, firstField: firstField, lastField: lastField })) })) }) }, item.id))) }));
});
export default ConfigureMetricsForm;
